import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const Jotai = props => {
  return <Dropdown.Static kubunKey='jotai' {...props} />
}
